import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import CategoryLabel from 'components/categoryLabel';
import CountDown from '../participates/countDown';
import alertSuccess from '../../assets/alert-success.svg';
import message from '../../assets/message.svg';

const NotifyComponent = () => {
  const { notify } = useSelector((state) => state.notify);

  const { imageHome, categoria, title, smallDescription, startDate,
    serverDate, maskEmail } = notify.data;

  return (
    <>
      {notify.error === false && (
        <Container className="bg-white">
          <Row className="py-60">
            <Col lg={{ span: 7, offset: 1 }} className="text-center">
              <h2 className="mb-15 text-tangaroa f-600">¡Notificación activada con éxito!</h2>
              <h3 className="mb-15">
                {`Cuando la Subasta esté disponible, enviaremos un correo a ${maskEmail}.`}
              </h3>
              <img src={alertSuccess} alt="noPoints-img" />

              <Row className="pt-30 text-left">
                <Col lg={6} className="px-0">
                  <div className="carousel-img">
                    <img className="image" src={imageHome} alt="img" />
                    <CategoryLabel
                      category={categoria} />
                  </div>
                </Col>
                <Col lg={6} className="bg-alabaster pb-15">
                  <h2 className="mt-15 text-tangaroa">
                    {title}
                  </h2>
                  <p className="text-tangaroa">{smallDescription}</p>
                  <p className="font-weight-bold text-tangaroa">Inicia en:</p>
                  <CountDown
                    closeDate={startDate}
                    todayDate={serverDate} />
                </Col>
              </Row>

              <h4 className="my-30 text-tangaroa">Haz clic en el botón de ‘Salir’ para continuar navegando en el sitio.</h4>
              <Link to="/" className="btn btn-primary mb-15" id="sbs-dsb-dgr-btn-mor">
                Salir
              </Link>
            </Col>
            <Col lg={3} className="">
              <div className="bg-westar p-3 br-1">
                <img src={message} alt="shoppingCart-img" />
                <h4 className="mt-15 text-tangaroa">Importante</h4>
                <h5 className="mt-15 text-tangaroa">Aún no has realizado ninguna puja.</h5>
              </div>
            </Col>
          </Row>
        </Container>
      )}
    </>
  );
};

export default NotifyComponent;
